import clsx from "clsx";

export const parent = clsx(" flex w-full justify-center items-center");
export const wrapper = clsx(
    "flex w-[90%] md:w-[70%] flex-col items-center rounded-lg bg-gray px-10 md:px-20 pb-20 pt-14",
);
export const title = clsx("text-2xl font-bold text-center uppercase md:text-4xl");
export const expandContainer = clsx("mt-10 flex w-full flex-col items-center");
export const tagContainer = clsx(
    "relative w-full border-b-[1px] border-b-black/40 py-4 first:border-t-2 first:border-t-[1px] first:border-t-black/40",
);
export const tagLabel = clsx(
    "flex cursor-pointer items-center justify-between md:text-lg",
);